import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { IoIosArrowForward } from "react-icons/io";

import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";
import PBCardDetails from "../components/PBCardDetails";
import CustomApplePayButton from "../../../common/CustomApplePayButton";
import CustomGooglePayButton from "../../../common/CustomGooglePayButton";
import CustomButton from "../../../common/CustomButton";
import Logout from "../../../common/Logout";
import IndiPlans from "../components/IndiPlans";
import PromoCode from "../components/PromoCode";

import { LoadPlans, CreatePurchase, CreatePurchaseDirect } from "../../../redux/v2/plan/actions";
import { GetCardDetails, UpdateBilling, LoadAccountDetails } from "../../../redux/v2/user/actions";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";

import "./style.css";

function Renew(props) {
    const navigate = useNavigate();
    const dt = localStorage.getItem("indi-device-type");

    const { billing, account } = props.User;
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedPlan, setSelectedPlan] = useState({});
    const [filteredPlan, setFilteredPlan] = useState([]);
    const [displayType, setDisplayType] = useState(1); //1 main renewal view, 2 change card details
    const expired = localStorage.getItem("expired");
    const offer = searchParams.get("offer");
    const renewButtonRef = useRef(null);
    const toDisplayPlans = expired
        ? {
            // this one is sign up for existing user with no live subscription redirected to chosing plan
            plans: ["monthly-renewal", offer == 1 ? "discount-annual-trial" : offer == 2 ? "discount-annual" : "annual-plan-renewal"],
            label: ["MONTHLY", "ANNUAL"],
            term: ["Month", "Year"],
        }
        : {
            // this one is signup for new user
            plans: ["monthly-free-trial", offer == 1 ? "discount-annual-trial" : offer == 2 ? "discount-annual" : "annual-free-trial"],
            label: ["MONTHLY", "ANNUAL"],
            term: ["Month", "Year"],
        };

    useEffect(() => {
        if (localStorage.getItem("expired")) {
            props.LoadPlans();
            props.GetCardDetails();
        }
    }, []);

    useEffect(() => {
        if (props.Plan.plans.length > 0) {
            let filtered = [];
            let selected = null;
            props.Plan.plans
                .sort((a, b) => b.interval_length - a.interval_length)
                ?.map((plan) => {
                    let planIndex = toDisplayPlans.plans.indexOf(plan.code);
                    if (planIndex > -1) {
                        filtered.push(plan);
                        if (filtered.length === 1) {
                            selected = plan;
                        }
                    }
                });
            setSelectedPlan(selected);
            setFilteredPlan(filtered);

            localStorage.setItem("current-selected-plan", JSON.stringify(selected));
        }
    }, [props.Plan.plans]);

    const postPurchase = async (res, toastId) => {
        if (res.status == 200) {
            const res2 = await props.LoadAccountDetails();

            toast.success("Plan subscribed successfully", {
                id: toastId,
            });

            localStorage.setItem("requirement_status", 3);
            localStorage.removeItem("expired");
            navigate("/");
        } else if (res.status == 406) {
            toast.error(res.message, {
                id: toastId,
            });
        } else if (res.status == 409) {
        } else if (res.status == 400) {
            toast.error("Bad request", {
                id: toastId,
            });
        } else {
        }
    };

    const onSubmitNewCard = async ({ err, token, formDetails, toastId }) => {
        if (err) {
            toast.error("Failed to updated card", {
                id: toastId,
            });
        } else {
            const res = await props.UpdateBilling({
                token: token,
            });

            if (res.success) {
                props.ShowModal(false);
                toast.success("Card successfully updated", {
                    id: toastId,
                });
            } else {
                toast.dismiss(toastId);
            }
        }
    };

    const onSubmitRenew = async () => {
        // e.preventDefault();

        const toastId = toast.loading("Creating purchase...");

        let couponArr = [];
        let createPurchaseObj = {
            first_name: account?.user?.first_name,
            last_name: account?.user?.last_name,
            currency: "USD",
            rjs_token: null,
            plan_id: selectedPlan.id,
            billing_zip: account?.user?.billing_zip,
            coupon_code: couponArr,
            renewal: true,
        };

        const res = await props.CreatePurchase(createPurchaseObj, selectedPlan);
        postPurchase(res, toastId);
    };

    const onSubmitRenewUsingApplePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];

        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: selectedPlan.id,
            coupon_code: coupon_code,
            renewal: true,
        };

        const res = await props.CreatePurchaseDirect(createPurchaseObj, selectedPlan);
        postPurchase(res, toastId);
    };

    const onSubmitRenewUsingGooglePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];

        const plan = JSON.parse(localStorage.getItem("current-selected-plan"));

        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: plan.id,
            coupon_code: coupon_code,
            renewal: true,
        };

        const res = await props.CreatePurchaseDirect(createPurchaseObj, plan);
        postPurchase(res, toastId);
    };

    const paymentMethod = billing.hasOwnProperty("cardType2") && (billing.cardType2 == "apple_pay" || billing.cardType2 == "google_pay") ? billing.cardType2?.split("_").join(" ") : `${billing.cardType2?.split("_")?.join(" ") || ""} (${billing.cardNumber || ""})`;

    return (
        <div id="renew-page" className="plan-v2-css">
            <Logout showLogo />

            <Grid id="renew-grid" container spacing={0}>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }} hidden={displayType != 1}>
                    <div style={{ maxWidth: "450px" }}>
                        <div id="plan-billing-banner-text">
                            <h3 onClick={() => { }}>RENEW YOUR MEMBERSHIP</h3>
                            <h5 className="error">Your membership has expired, please renew your membership below to continue.</h5>
                        </div>
                        <div className="auth-box" style={{ padding: "0 30px 50px 30px" }}>
                            <div className="container">
                                <IndiPlans
                                    plans={filteredPlan}
                                    selectedPlan={selectedPlan}
                                    setSelectedPlan={setSelectedPlan}
                                    promoCodeArea={
                                        <div id="promo-code-banner">
                                            <h5
                                                onClick={() => {
                                                    props.SetModalProperties({
                                                        height: "320px",
                                                        isShow: true,
                                                        title: "",
                                                        body: (
                                                            <>
                                                                <PromoCode
                                                                    type="renew"
                                                                    close={() => {
                                                                        props.ShowModal(false);
                                                                    }}
                                                                />
                                                            </>
                                                        ),
                                                        actions: [],
                                                    });
                                                }}
                                            >
                                                Enter Promo Code <IoIosArrowForward />
                                            </h5>
                                        </div>
                                    }
                                />

                                <h4>CHOOSE PAYMENT METHOD</h4>

                                {dt === "ios" && (
                                    <div id="payment-provider-div">
                                        <CustomApplePayButton
                                            type="renew"
                                            plan={selectedPlan}
                                            applePayCallButtonback={(token) => {
                                                onSubmitRenewUsingApplePay(token);
                                            }}
                                        />
                                    </div>
                                )}
                                <div id="payment-provider-div" style={{ width: "100%", paddingTop: "0" }}>
                                    <CustomGooglePayButton
                                        type="renew"
                                        plan={selectedPlan}
                                        googlePayCallButtonback={(token) => {
                                            onSubmitRenewUsingGooglePay(token);
                                        }}
                                    />
                                </div>

                                <CustomButton
                                    ref={renewButtonRef}
                                    onClick={() => {
                                        props.SetModalProperties({
                                            height: "320px",
                                            isShow: true,
                                            title: "",
                                            body: (
                                                <>
                                                    <div id="renew-slider-modal">
                                                        <p>Your plan will renew for ${selectedPlan.amount}.</p>
                                                        <p style={{ textTransform: "capitalize" }}>Payment Method: {paymentMethod}</p>
                                                        <div className="buttons">
                                                            <CustomButton
                                                                onClick={() => {
                                                                    // setShowModal(!showModal);
                                                                    // setDisplayType(2);

                                                                    props.SetModalProperties({
                                                                        height: "320px",
                                                                        isShow: true,
                                                                        title: "",
                                                                        body: (
                                                                            <>
                                                                                <PBCardDetails
                                                                                    type="update"
                                                                                    card={{
                                                                                        type: billing.hasOwnProperty("cardType2") && (billing.cardType2 == "apple_pay" || billing.cardType2 == "google_pay") ? billing.cardType2?.split("_").join(" ") : billing.cardType2?.split("_")?.join(" ") || "",
                                                                                        cardNumber: billing.cardNumber,
                                                                                    }}
                                                                                    callback={(response) => {
                                                                                        onSubmitNewCard({
                                                                                            ...response,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </>
                                                                        ),
                                                                        actions: [],
                                                                    });
                                                                }}
                                                            >
                                                                Change Billing
                                                            </CustomButton>
                                                            <CustomButton
                                                                onClick={() => {
                                                                    onSubmitRenew();
                                                                }}
                                                            >
                                                                Confirm Renew
                                                            </CustomButton>
                                                        </div>
                                                    </div>
                                                </>
                                            ),
                                            actions: [],
                                        });

                                        // setShowModal(!showModal);
                                    }}
                                >
                                    Renew with Credit Card
                                </CustomButton>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>

            <CustomModalWrapper />
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Plan: state.Plan,
});

export default connect(mapStateToProps, {
    LoadPlans,
    GetCardDetails,
    CreatePurchase,
    CreatePurchaseDirect,
    UpdateBilling,
    SetModalProperties,
    ShowModal,
    LoadAccountDetails,
})(Renew);
